import api from 'api';
import useFeature from 'hooks/useFeature';
import { useQuery } from 'react-query';

export const useOfficeLocationById = (officeLocationId?: number) => {
  const { isEsicMultiLocationEnabled } = useFeature('esicMultiLocation');
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['office-location', officeLocationId],
    queryFn: () =>
      api.officeLocation.getOfficeLocationById({
        officeLocationId: officeLocationId!,
      }),
    enabled: isEsicMultiLocationEnabled && !!officeLocationId,
  });

  return {
    data: data?.data,
    isFetchingOfficeLocation: isLoading || isFetching,
  };
};
